import api from './api';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const permissionService = {
  // ============================================================================
  // ROLE MANAGEMENT
  // ============================================================================

  // Get all roles (excluding Superadmin and Patient)
  getRoles: async () => {
    try {
      const response = await api.get('/permissions/roles');
      return response.data;
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw error;
    }
  },

  // Get single role by ID
  getRole: async (roleId) => {
    try {
      const response = await api.get(`/permissions/roles/${roleId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching role:', error);
      throw error;
    }
  },

  // Get next available role id
  getNextRoleId: async () => {
    try {
      const response = await api.get('/permissions/roles/next-id');
      return response.data;
    } catch (error) {
      console.error('Error fetching next role ID:', error);
      throw error;
    }
  },

  // Create new role
  createRole: async (roleData) => {
    try {
      const response = await api.post('/permissions/roles', roleData);
      return response.data;
    } catch (error) {
      console.error('Error creating role:', error);
      throw error;
    }
  },

  // Update existing role
  updateRole: async (roleData) => {
    try {
      const response = await api.put('/permissions/roles', roleData);
      return response.data;
    } catch (error) {
      console.error('Error updating role:', error);
      throw error;
    }
  },

  // ============================================================================
  // PERMISSION MANAGEMENT
  // ============================================================================

  // Get all permissions with page names
  getPermissions: async () => {
    try {
      const response = await api.get('/permissions/permissions');
      return response.data;
    } catch (error) {
      console.error('Error fetching permissions:', error);
      throw error;
    }
  },

  // Get single permission by ID
  getPermission: async (permissionId) => {
    try {
      const response = await api.get(`/permissions/permissions/${permissionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching permission:', error);
      throw error;
    }
  },

  // Get all pages (for dropdown)
  getPages: async () => {
    try {
      const response = await api.get('/permissions/pages');
      return response.data;
    } catch (error) {
      console.error('Error fetching pages:', error);
      throw error;
    }
  },

  // Create new permission
  createPermission: async (permissionData) => {
    try {
      const response = await api.post('/permissions/permissions', permissionData);
      return response.data;
    } catch (error) {
      console.error('Error creating permission:', error);
      throw error;
    }
  },

  // Update existing permission
  updatePermission: async (permissionData) => {
    try {
      const response = await api.put('/permissions/permissions', permissionData);
      return response.data;
    } catch (error) {
      console.error('Error updating permission:', error);
      throw error;
    }
  },

  // ============================================================================
  // ROLE PERMISSION ASSIGNMENT
  // ============================================================================

  // Get permissions for a specific role
  getRolePermissions: async (roleId) => {
    try {
      const response = await api.get(`/permissions/roles/${roleId}/permissions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching role permissions:', error);
      throw error;
    }
  },

  // Assign permissions to a role
  assignRolePermissions: async (roleId, permissionIds) => {
    try {
      const response = await api.post(`/permissions/roles/${roleId}/permissions`, {
        role_id: roleId,
        permission: permissionIds
      });
      return response.data;
    } catch (error) {
      console.error('Error assigning role permissions:', error);
      throw error;
    }
  }
};

export default permissionService;

